import React, { useState } from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import QuoteForm from "./QuoteForm";

const FloatingButton = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* Floating button */}
      <Button
        onClick={handleClickOpen}
        variant="contained"
        style={{
          position: "fixed",
          top: "50%", // Center vertically
          right: "-47px", // Align to the right
          transform: "translateY(-50%) rotate(90deg)", // Adjust position for vertical centering
          background: "linear-gradient(to right, #2D0B5A, #C106A3)",
          color: "white",
          fontWeight: "bold",
          zIndex: 1000,
          
        }}
      >
        Get a Quote
      </Button>

      {/* Form Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogContent>
          <QuoteForm />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingButton;
